import { Button } from "primereact/button";
import { useState } from "react";
import { genElObject, genElText } from "../../../../components/utils/EditorDialogElementGenerator";
import CustomerSelectorMain from "../../../selectors/customer-selector/component/customer-selector-main";
import { useSelector } from "react-redux";

const CustomerDiscountFilter = (props) => {
  const { filterValue, setFilterValue, onClickRefresh } = props;
  const employee = useSelector((state) => state.auth.employee);

  const [showCustomerSelector, setShowCustomerSelector] = useState(false);

  const handleOnClickCustomer = () => {
    setShowCustomerSelector(true);
  };

  const handleOnConfirmCustomer = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setFilterValue({ ...filterValue, data_customer: selected, customer_id: selected.id });
      setShowCustomerSelector(false);
    }
    return selected;
  };

  const elCustomer = genElObject({
    field: 'customer_id',
    name: 'Customer',
    value: filterValue.data_customer ? filterValue.data_customer.name : '',
    onClick: handleOnClickCustomer,
    onClear: () => {
      setFilterValue({ ...filterValue, data_customer: null, customer_id: null });
    },
  });

  const elDiscount = genElText({
    field: 'name',
    name: 'Discount Name',
    data: filterValue,
    setData: (newData) => setFilterValue({ ...filterValue, name: newData.name }),
    error: {},
  });

  return (
    <div className="flex flex-col sm:flex-row justify-center items-end gap-4 w-full">
      <CustomerSelectorMain
        title={'Select Customer'}
        visible={showCustomerSelector}
        onHide={() => setShowCustomerSelector(false)}
        onConfirm={handleOnConfirmCustomer}
        additionalFilter={employee?.user_type == 3 ? `bc_id:=:${employee.id}` : ''}
      />

      {/* filter component section */}
      <div className="flex flex-col sm:flex-row justify-start items-center gap-4 w-full">
        {elCustomer}
        {elDiscount}
      </div>
      {/* refresh section */}
      <Button
        icon="pi pi-refresh"
        outlined
        rounded
        onClick={() => {
          if (onClickRefresh) onClickRefresh();
        }}
      />
    </div>
  );
};

export default CustomerDiscountFilter;
